import { useMutation, useQueryClient } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';

const uploadFixedBudgetVesselQuery = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return axios.post(apiurl?.uploadFixedBudgetVessel, formData, {
    headers: {
      Accept: '*/*'
    },
    validateStatus: (status) => status >= 200 && status < 600
  });
};

const uploadFixedBudgetVessel = () => {
  const queryClient = useQueryClient();
  return useMutation(uploadFixedBudgetVesselQuery, {
    onSuccess: () => {
      queryClient.invalidateQueries('getFixedBudgetVesselList');
    }
  });
};

export default uploadFixedBudgetVessel;
